import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'v-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss']
})
export class VStepperComponent implements OnInit {
    @Input() stepTitle: string;
    @Input() stepNumber: number;
    @Input() stepDescription: string;
    @Input() stepValide: boolean;

    constructor() {}

    ngOnInit(): void {}
}
